import React from 'react'
import styles from './TypeDropdown.module.css'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

function TypeDropdown({setSelectedResource, Food, Plasma,setResourceClass,value}) {

    const types = ['Food', 'Plasma', 'Oxygen', 'Beds', 'Remdesivir']
    const food = ['Vegetarian', 'Non-Vegetarian', 'Both']
    const blood = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']

    const updateValue = (selected) => {
        if(Food | Plasma){
            setResourceClass(selected.value)
        }
        else{
            setSelectedResource(selected.value)
            setResourceClass('')
        }
    }


    return (
        <div>
        <Dropdown options={(Food)? food : Plasma? blood : types} value={value} placeholder="Select resource type" onChange={(selected)=> updateValue(selected)}/>
        </div>
    )
}

export default TypeDropdown
